import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSchoolByXid } from '../api/get-school-by-xid';
import { handleApiError, ApiError } from '../../../common/utils/api-utils';

export const fetchSchoolByXid = createAsyncThunk(
  'userProfile/getSchoolById',
  async (xid: string, thunkAPI) => {
    try {
      return await getSchoolByXid(xid);
    } catch (error) {
      console.error(error);
      if (error instanceof ApiError) {
        handleApiError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);
